<template>
	<div id="app">
		<!-- <div>头部</div> -->
		<!--  v-if="topic" -->
		<div class="NavBar" v-if="topic.headImageUrl">
			<div class="NavBarBg" :style="{ opacity: navBarOpacity }"></div>
			<div class="AppBack" @click="appBack">
				<svg
					width="20px"
					height="20px"
					viewBox="0 0 20 20"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
				>
					<g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<g id="推荐专题-列表页备份-28" transform="translate(-16.000000, -56.000000)">
							<g id="-mockplus-" transform="translate(0.000000, 44.000000)">
								<g id="icon返回" transform="translate(16.000000, 12.000000)">
									<path
										d="M8.408,17.811 L1.175,10.576 C0.941390267,10.2260734 0.941390267,9.76992665 1.175,9.42 L8.408,2.186 C8.65734146,1.93944321 9.05865854,1.93944321 9.308,2.186 L9.761,2.638 C10.0070164,2.88756326 10.0070164,3.28843674 9.761,3.538 L3.31,10 L9.765,16.455 C10.0115568,16.7043415 10.0115568,17.1056585 9.765,17.355 L9.312,17.808 C9.06288201,18.0551 8.66111799,18.0551 8.412,17.808 L8.412,17.808 L8.408,17.811 Z"
										id="_25_返回箭头"
										:fill="svgColor"
										fill-rule="nonzero"
									></path>
									<rect id="矩形_533" x="0" y="0" width="20" height="20"></rect>
								</g>
							</g>
						</g>
					</g>
				</svg>
			</div>
			<div class="AppTitle" :style="{ opacity: navBarOpacity }">{{ topic.title }}</div>
			<div class="AppShare" @click="appShare">
				<svg
					width="20px"
					height="20px"
					viewBox="0 0 20 20"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
				>
					<g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<g id="推荐专题-列表页备份-28" transform="translate(-339.000000, -56.000000)">
							<g id="-mockplus-" transform="translate(0.000000, 44.000000)">
								<g id="右icon" transform="translate(255.000000, 0.000000)">
									<g id="icon分享" transform="translate(84.000000, 12.000000)">
										<rect id="矩形_540" x="-1.42108547e-14" y="0" width="20" height="20"></rect>
										<g id="icon_NavShare_20x20_Whtie" transform="translate(0.000000, 0.300000)">
											<rect
												id="bg"
												fill-opacity="0"
												fill="#D8D8D8"
												fill-rule="nonzero"
												x="0"
												y="0"
												width="20"
												height="20"
											></rect>
											<g id="iocn">
												<rect id="矩形_549" x="0" y="0" width="20" height="20"></rect>
												<path
													d="M12.571,2 L16.857,2 C17.4882615,2 18,2.51173853 18,3.143 L18,7.429 M18,12.572 L18,15.715 C17.9994479,16.9771324 16.9761325,18 15.714,18 L4.286,18 C3.02347706,18 2,16.9765229 2,15.714 L2,4.286 C2,3.02347706 3.02347706,2 4.286,2 L7.429,2"
													id="形状"
													:stroke="svgColor"
													stroke-width="2"
													stroke-linecap="round"
													stroke-linejoin="round"
												></path>
												<rect
													id="矩形"
													:stroke="svgColor"
													transform="translate(12.775796, 7.224310) rotate(45.000000) translate(-12.775796, -7.224310) "
													x="12.2757964"
													y="1.08131035"
													width="1"
													height="12.286"
													rx="0.5"
												></rect>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</svg>
			</div>
		</div>
		<!--  v-if="notTopic"  v-if="JSON.stringify(topic) != '{}'" -->
		<div class="topBanner" v-if="topic.headImageUrl">
			<template v-if="topic">
				<!-- <transition name="fade"> -->
				<img v-show="topic.headImageUrl" :src="topic.headImageUrl" />
				<!-- </transition> -->
				<div v-show="topic.headImageUrl" class="mask"></div>
				<div class="topBannerContent">
					<p v-show="topic.headImageUrl">
						{{ topic.title }}
						<!-- <a
                            v-if="topic.clubInfo"
                            :href="topic.clubInfo.contentUrl"
                            >前往圈子</a
                        > -->
					</p>
					<p v-show="topic.description != ''">
						{{ topic.description }}
					</p>
					<a v-if="topic.clubInfo" :href="topic.clubInfo.contentUrl">前往圈子<i></i></a>
				</div>
			</template>
		</div>

		<loading-list :onLoadMore="onLoadMore" :enableLoadMore="enableLoadMore" :noMore="noMore">
			<!-- tab切换 -->
			<template v-for="(item, index) in listElements.length > 0 ? listElements : 0">
				<list-nav
					v-if="typeof item == 'object' && item.type == 'xuanXiangKa'"
					:key="'xuanXiangKa' + index"
					:topicItem="item"
					@changeTopicNav="changeTopicNav"
				></list-nav>

				<div
					class="game-biaoTiLan"
					v-else-if="typeof item == 'object' && item.type == 'biaoTiLan'"
					:key="'biaoTiLan' + index"
				>
					{{ item.title }}
				</div>
				<!-- style="display: none;" -->

				<game-item
					v-else-if="typeof item == 'object' && item.type.indexOf('youXi') != -1"
					:key="'gameItem' + index"
					:data-index="index"
					:result="item"
				></game-item>

				<news-item v-else :key="'newsItem' + index" :data-index="index" :result="item"></news-item>
			</template>
		</loading-list>
	</div>
</template>
<script>
import { topicPage } from "../../api/request";
import gameItem from "../../components/gameItem";
import newsItem from "../../components/newsItem";
import LoadingList from "../../components/LoadingList";
import listNav from "../../components/listNav";
export default {
	name: "App",
	components: { gameItem, newsItem, LoadingList, listNav },
	data ()
	{
		return {
			contentUrl: window.location.href,
			listElements: [],
			topic: {},
			notTopic: this.getQueryString("gameTags") ? false : true,
			pageIndex: 0,
			pageSize: 20,
			enableLoadMore: true,
			noMore: false,
			ColorMode: this.getQueryString("gsAppColorMode") || "light",
			topicNavIndex: 0,
			contentType: "",
			navBarOpacity: 0,
			svgColor: "rgb(255, 255, 255)"
		};
	},
	mounted ()
	{
		let that = this;
		GSAppJsApi.UI.setFullScreen();
		// window.toDidReceiveQueryParam = (queryParam) => {
		//     that.contentUrl = `${window.location.href}?${decodeURIComponent(queryParam)}`
		// }
		this.$nextTick(() =>
		{
			if (this.ColorMode == "dark")
			{
				window.document.documentElement.setAttribute("data-theme", "Dark");
			} else
			{
				window.document.documentElement.removeAttribute("data-theme");
			}
			GSAppJsApi.UI.registerSetPageUI(function (theme)
			{
				if (theme == "Dark")
				{
					window.document.documentElement.setAttribute("data-theme", "Dark");
				} else
				{
					window.document.documentElement.removeAttribute("data-theme");
				}
			});

			window.onscroll = function ()
			{
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				let opacity, svgColor;
				if (that.ColorMode == "dark")
				{
					that.svgColor = "rgb(255, 255, 255)";
				} else
				{
					if (scrollTop <= 255)
					{
						svgColor = 255 - scrollTop;
						that.svgColor = "rgb(" + svgColor + ", " + svgColor + ", " + svgColor + ")";
					} else
					{
						that.svgColor = "rgb(0, 0, 0)";
					}
				}

				if (scrollTop <= 280)
				{
					opacity = scrollTop / 280;
					that.navBarOpacity = opacity;


					if (that.$utils.isiOS())
					{
						opacity > 0.5 ? GSAppJsApi.UI.setBrowserUI("Dark", true, true) : GSAppJsApi.UI.setBrowserUI("Light", true, true);
					}
				} else
				{
					that.navBarOpacity = 1;
					if (that.$utils.isiOS())
					{
						GSAppJsApi.UI.setBrowserUI("Dark", true, true);
					}
				}
			};
		});


		if (!this.getQueryString("topicId") && !this.getQueryString("gameTags") && !this.getQueryString("gameRankListName"))
		{
			GSAppJsApi.Page.getQueryParams(function (queryParams)
			{
				let contentUrl = `${window.location.origin}${window.location.pathname}?${decodeURIComponent(
					queryParams
				).replace("?", "")}`;
				that.contentUrl = contentUrl;
				that.GetTopicPage();
			});
		} else
		{
			this.GetTopicPage();
		}



		// if (window._gsApp_queryParamsNeedSetAfterLoadEncoded) {
		//     let contentUrl = `${window.location.origin}${window.location.pathname}?${decodeURIComponent(
		//         window._gsApp_queryParamsNeedSetAfterLoadEncoded
		//     ).replace("?", "")}`;
		//     that.contentUrl = contentUrl;
		//     that.GetTopicPage();

		// } else {
		//     window.toDidReceiveQueryParam = queryParam => {
		//         let contentUrl = `${window.location.href}?${decodeURIComponent(queryParam).replace("?", "")}`;
		//         that.contentUrl = contentUrl;
		//         that.GetTopicPage();
		//     };
		// }
	},
	destroyed () { },
	methods: {
		didTopicLoaded () 
		{
			// 专题加载后，开始加载统计代码：

			// document.getElementById("loadinges").style.opacity = 1;

			// window.toDidReceiveQueryParam = queryParam => {
			//     window.queryParm = decodeURIComponent(queryParam);
			// };
			this.$nextTick(() =>
			{
				var _bdhmProtocol = "https:" == document.location.protocol ? " https://" : " //";
				var hm = document.createElement("script");
				hm.src = "https://hm.baidu.com/hm.js?0184f3798bd9a251c44cc969d5fe3855";
				var h = document.createElement("script");
				h.src = _bdhmProtocol + "hm.baidu.com/h.js%3Fdcb5060fba0123ff56d253331f28db6a";
				var s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(hm, s);
				s.parentNode.insertBefore(h, s);

				var jweixin = document.createElement("script");
				jweixin.src = "https://res.wx.qq.com/open/js/jweixin-1.4.0.js";
				document.body.appendChild(jweixin);
			});
		},
		onLoadMore (done)
		{
			if (!this.enableLoadMore)
			{
				return;
			}
			this.pageIndex = this.pageIndex + 1;
			this.GetTopicPage(() =>
			{
				done();
			});
		},
		GetTopicPage (callback)
		{
			// this.$loading();
			// console.log(this.contentUrl);
			this.enableLoadMore = false;

			topicPage({
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
				contentType: this.contentType,
				contentUrl: this.contentUrl,
				// contentUrl: window.location.href,
				// contentUrl: "https://app.gamersky.com/zt/post/topicPage.html?topicId=34&gsAppColorMode=light",
				// contentUrl: "https://app.gamersky.com/zt/post/topicPage.html?topicId=86"
				// contentUrl: "https://app.gamersky.com/zt/post/topicPage.html?topicId=37"
				// contentUrl: "https://app.gamersky.com/zt/post/topicPage.html?topicId=27"
				// contentUrl: "https://app.gamersky.com/zt/post/topicPage.html?topicId=41",
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=1012",
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=947",
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=1195",
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?gameTags=角色扮演",
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=158&appNavigationBarStyle=kNoneBar&appStatusBarStyle=kLightBar",
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=1022&appNavigationBarStyle=kNoneBar&appStatusBarStyle=kLightBar&nodeId=1022"
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=1032&appNavigationBarStyle=kNoneBar&appStatusBarStyle=kLightBar&nodeId=1032&gsAppColorMode=light"
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=1069&appNavigationBarStyle=kNoneBar&shareRef=App_iOS"
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=1223",
				// contentUrl: "https://app.gamersky.com/zt/game/topicPage.html?topicId=1273"
			}).then(res =>
			{
				if (res.error == "")
				{
					if (res.topic)
					{
						this.topic = res.topic;
						res.topic.shareInfo = res.topic.shareInfo ? res.topic.shareInfo : res.topic;
						if (res.topic.shareInfo)
						{
							GSAppJsApi.Page.shareInfo = {
								thumbnailUrl: res.topic.shareInfo.thumbnailUrl, // 分享缩略图Url
								title: res.topic.shareInfo.title, // 分享标题
								description: res.topic.shareInfo.description, // 分享描述
								contentUrl: res.topic.shareInfo.contentUrl, // 内容链接
								contentImageUrl: "" // 截图分享地址
							};
							// 微信分享
							this.$bussiness.WeChatShare({
								title: res.topic.shareInfo.title, // 分享标题
								description: res.topic.shareInfo.description, // 分享描述
								shareUrl: res.topic.shareInfo.contentUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
								sharePic: res.topic.shareInfo.thumbnailUrl // 分享图标
							});
						}
						GSAppJsApi.UI.setTitle(res.topic.title);
					} else
					{
						this.notTopic = false;
					}
					if (typeof callback == "function")
					{
						callback();
					}
					if (res.listElements && res.listElements.length > 0)
					{
						// XGP专题的特殊处理：
						try
						{
							if (res.topic.id == 1273)
							{
								for (var listElement of res.listElements)
								{
									listElement.type = "youXi_HengBan_PingFen_BiaoQian_PingTai__XiangWan";
								}
							}
						}
						catch (exception)
						{
							console.warning(exception);
						}

						if (res.listElements.length < this.pageSize)
						{
							this.noMore = true;
						}
						if (!this.notTopic)
						{
							document.title = res.listElements[0].title;
						}
						if (this.pageIndex == 0)
						{
							this.listElements = res.listElements;
						}
						else
						{
							this.listElements = this.listElements.concat(res.listElements);
						}
						this.$nextTick(() =>
						{
							this.enableLoadMore = true;
						});
					} else
					{
						this.noMore = true;
						this.enableLoadMore = false;
					}
				}
				let loading = document.getElementById("loadinges");
				if (loading)
				{
					loading.remove();
				}
				// this.$loading.close();

				// !!!
				this.didTopicLoaded();
				// !!!
			});
		},
		// tab切换
		changeTopicNav (caption)
		{
			this.pageIndex = 0;
			this.contentType = caption;
			this.GetTopicPage();
		},
		//转码
		GetQueryString (name)
		{
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return decodeURIComponent(r[2]);
			return null;
		},
		getQueryString: function (name)
		{
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		},
		// app返回
		appBack ()
		{
			GSAppJsApi.UI.close();
		},
		// app分享
		appShare ()
		{
			let topic = this.topic;
			let shareInfo = topic.shareInfo;
			let ShareInfo = GSAppJsApi.UI.createShareInfo(
				"renYi", // 分享平台，可选值：renYi, qq, weiXin, pengYouQuan, weiBo
				shareInfo.thumbnailUrl, // 缩略图url
				shareInfo.title, // 标题
				shareInfo.description, // 描述
				shareInfo.contentUrl, // 跳转地址
				"" // 分享图片地址
			);
			// App分享
			GSAppJsApi.UI.share(ShareInfo);
		}
	}
};
</script>
<style lang="scss" scoped>
.content {
	position: relative;
	z-index: 2;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
	overflow: hidden;
	// background: #fff;
	// @include Body_Background($Body_Background);
	.topicNav {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		padding: 0 16px;
		box-sizing: border-box;
		.topicNavItem {
			position: relative;
			height: 22px;
			line-height: 22px;
			font-size: 15px;
			font-weight: 500;
			@include Color2($Color2);
			margin-right: 22px;
			cursor: pointer;
			&:last-child {
				margin-right: 0;
			}
			&.cur {
				@include newsContentColor($newsContentColor);
				&::before {
					content: "";
					display: block;
					position: absolute;
					left: 50%;
					bottom: -2px;
					transform: translateX(-50%);
					width: 16px;
					height: 3px;
					border-radius: 2px;
					background: #eb413d;
				}
			}
		}
	}
	.game-biaoTiLan {
		padding: 20px 16px 0;
		display: flex;
		align-items: center;
		height: 32px;
		width: 100%;
		font-size: 15px;
		@include newsContentColor($newsContentColor);
		font-weight: 500;
	}
	.contentItem {
		width: 100%;
		box-sizing: border-box;
		img {
			border-radius: 3px;
			width: 100%;
			height: 70px;
			object-fit: cover;
			flex: 0.3;
		}
		.text {
			flex: 0.65;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			.title {
				font-size: 14px;
				font-weight: bold;
				color: #000;
			}
			span {
				font-size: 11px;
				height: 20px;
				color: #bfbfbf;
				line-height: 20px;
				margin-bottom: 5px;
				&:last-of-type {
					margin-left: 10px;
				}
			}
		}
	}
}
</style>
